// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=AreaMeasurementUnit|schemaHash=cbfe5d9303dcbf092a9d7f6eb95347e12955ac9c

import { setDefinedValue } from '@myre/common-primitives';

export function parseAreaMeasurementUnitFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'code', _data.code);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'meterConversionRate', _data.meterConversionRate);
  setDefinedValue(result, 'id', _data.id);

  return result;
}

export function parseAreaMeasurementUnitToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'code', _data.code);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'meterConversionRate', _data.meterConversionRate);
  setDefinedValue(result, 'id', _data.id);

  return result;
}
